import { Length } from './length';

// Offset to account for Fullbleed margins in the studio
const STUDIO_FULLBLEED_OFFSET_INCHES = 0.25;
const MIN_DIMENSION_INCHES = 3;

export const getStudioUrl = (docUrl: string, panelWidth: string, panelHeight: string): string => {
    const baseUrl = 'https://www.vistaprint.com/studio/';

    const widthInches = Length.parse(panelWidth).toInches().value;
    const heightInches = Length.parse(panelHeight).toInches().value;

    const finalWidth = Math.max(widthInches - STUDIO_FULLBLEED_OFFSET_INCHES, MIN_DIMENSION_INCHES);
    const finalHeight = Math.max(heightInches - STUDIO_FULLBLEED_OFFSET_INCHES, MIN_DIMENSION_INCHES);

    const selectedOptions = {
        'Custom Height': Math.round(finalHeight * 100) / 100,
        'Custom Width': Math.round(finalWidth * 100) / 100,
        Material: 'Opaque',
        Shape: 'Rectangle',
        Size: 'Custom',
        Orientation: finalWidth >= finalHeight ? 'Horizontal' : 'Vertical',
    } as Record<string, string | number>;

    const params = new URLSearchParams({
        key: 'PRD-XROFY2WA',
        productVersion: '16',
        selectedOptions: JSON.stringify(selectedOptions),
        documentUrl: docUrl,
    });

    return `${baseUrl}?${params.toString()}`;
};
